<div *ngIf="open" class="text-modal-overlay" (click)="onOverlayClick()">
  <div class="text-modal-content" (click)="$event.stopPropagation()">
    <div class="text-modal-header">
      <h2>{{ title }}</h2>
      <button
        type="button"
        class="modal-close"
        (click)="close()"
        [attr.aria-label]="'dashboard.common.close' | translate">
        ×
      </button>
    </div>
    <div class="text-modal-body">
      <div class="text-content">{{ text }}</div>
    </div>
  </div>
</div>
